module.exports = __webpack_public_path__ + "static/media/fondoBlanco.83a407ff.png";